/*
 * Behavior governing result lists.
 */
var ResultsController = (function ($) {
  
  var doc, loadMoreUrl = '/foo/bar',
      results, fakeResults;
  
  function ready() {
    doc = $(document.body);
    doc.on('click', '.load-more', onLoadMoreClick);
    
    results = $(".results");
    fakeResults = results.children('li').clone();

  }
  
  function onLoadMoreClick(e) {
    e.preventDefault();
    
    $.ajax(loadMoreUrl)
      .done(function () {
        // TODO: Make an actual request for data.
      })
      .fail(function () {
        
      })
      .always(function () {
        // For now, just duplicate the results to simulate the behavior.
        // TODO: Get rid of this dummy behavior once the feature is implemented.
        var last = results.children('li').last();
        
        fakeResults = fakeResults.clone();
        fakeResults.css('opacity', 0);
        results.append(fakeResults);
        ScrollController.scrollTo(last);
        fakeResults.animate({opacity: 1}, 750, 'easeOutQuart');
        GridController.equalizeGrids();
        
      });
  }

  
  $(ready);
  
})(jQuery);